import { useMemo } from "react";
import { useRecentlyViewed } from "@/lib/pdp/recently-viewed";
import type { CatalogProduct } from "@/lib/catalog/products";
import { RelatedProducts } from "./RelatedProducts";

export function RecentlyViewed({ excludeSlug, catalog }: { excludeSlug: string; catalog: CatalogProduct[] }) {
  const slugs = useRecentlyViewed(excludeSlug);
  const seeded = useMemo(
    () =>
      slugs
        .map((s) => catalog.find((p) => p.slug === s))
        .filter((p): p is CatalogProduct => Boolean(p))
        .slice(0, 4),
    [slugs, catalog],
  );
  if (seeded.length === 0) return null;
  return <RelatedProducts title="Recently Viewed" eyebrow="Your Trail" products={seeded} />;
}
